import { LocalFind, LocalInsert } from '@weblite/persist'
import { ProfilerData, setProfilerConfig } from '@weblite/profiler'
import { connectionStatusView } from '$comp/main/root.reducer'
import {
  ProfilerAction,
  ProfilerAnalyticsEventType,
  shouldProfileUserPerformance,
  ignoreUserCoverageActions,
} from '$logic/profiler'
import { socketDisconnectedAction } from '$hooks/after/disconnection'
import { getClientUserId } from '$logic/client-user'

setProfilerConfig({
  onLogAvailable: sendProfilerEvent,
  disconnectionAction: socketDisconnectedAction,
  getConnectionStatus: () => {
    const connectionStatus = connectionStatusView()
    return connectionStatus === 'connected' || connectionStatus === 'updating'
  },
})

let cachedShouldProfilePerformance: boolean
const LOCAL_STORAGE_KEY = 'shouldProfileUserPerformance'

const getShouldProfilePerformance = () => {
  if (cachedShouldProfilePerformance === undefined) {
    const shouldProfilePerformance = LocalFind(LOCAL_STORAGE_KEY)
    if (shouldProfilePerformance != null) {
      cachedShouldProfilePerformance = shouldProfilePerformance
      return shouldProfilePerformance
    }

    const userId = getClientUserId()
    if (!userId) return false

    const userIdIsCovered = shouldProfileUserPerformance(userId)
    cachedShouldProfilePerformance = userIdIsCovered
    LocalInsert(LOCAL_STORAGE_KEY, userIdIsCovered)

    return userIdIsCovered
  }

  return cachedShouldProfilePerformance
}

export function sendProfilerEvent(action: string, data: ProfilerData) {
  // eslint-disable-next-line no-console
  if (import.meta.env.DEV) console.log('[profiler]:', { action, ...data })

  const ignoreUserCoverage = ignoreUserCoverageActions.includes(
    action as ProfilerAction,
  )
  if (ignoreUserCoverage || getShouldProfilePerformance())
    analite(ProfilerAnalyticsEventType, {
      action,
      ...data,
    })
}
